import { Type } from '@sinclair/typebox';
import { NullishType } from '../../standard-schema.js';
const AfterMarketVisitSchema = Type.Object({
    id: Type.String(),
    projectId: Type.String(),
    text: Type.String(),
    date: NullishType(Type.String()),
});
export const InsertAfterMarketVisitSchema = Type.Pick(AfterMarketVisitSchema, [
    'projectId',
    'text',
    'date',
]);
export const UpdateAfterMarketVisitSchema = Type.Partial(Type.Pick(AfterMarketVisitSchema, ['text', 'date']));
export const SelectAfterMarketVisitSchema = Type.Pick(AfterMarketVisitSchema, [
    'id',
    'projectId',
    'text',
    'date',
]);
